/**
 * El contrato de una respuesta del `APIClient`, en un solo lugar.
 *
 * Existe por el gotcha del CLAUDE.md: `status === 'ERROR'` es un COLADOR. `ErrorResponse._data()`
 * del backend escribe en `status` el codigo TIPADO del error (`MISSING_CLIENT`, `NO_MODULE_ACCESS`,
 * `ERROR_NO_AGENCY`, `EMAIL_IS_AGENCY_USER`...), y el propio `APIClient` inventa un `NETWORK_ERROR`
 * sintetico cuando el fetch falla. Ninguno de los dos vale `'ERROR'`, asi que un caller que pregunte
 * por ese literal se los come; y si ademas su guarda es NEGATIVA
 * (`if (status === 'ERROR') {...} else {...}`) los manda por la rama de EXITO, que deref-ea
 * `response.data.<prop>` sobre algo que no existe. Eso es FRONTEND-47.
 *
 * La funcion es la que vivia en `api/informesApi.js`: no tiene nada de Informes -- es el contrato
 * del cliente HTTP. Ese modulo la re-exporta para no tocar a sus consumidores.
 *
 * OJO: `isOk` solo sirve contra endpoints que responden con `OKResponse` (o `CreatedResponse` /
 * `DeletedResponse`, que tambien mandan `status:'OK'`). Una vista vieja que devuelve el payload
 * pelado (`Response({'reports': [...]})`) llega con 200 y SIN la clave `status`, asi que `isOk` da
 * `false` y la pantalla se iria a un error inexistente -- es lo que paso con `PortalReportsLanding`
 * (commit 360f022). Para esas, guarda por la FORMA de la respuesta (`!Array.isArray(response.reports)`).
 * La lista de vistas peladas conocidas esta en el CLAUDE.md.
 */
export function isOk(response) {
    return !!response && response.status === 'OK';
}

/**
 * El fallo de red sintetico del propio `APIClient`, no un error del backend.
 *
 * Sirve para UNA cosa: elegir el copy. El `error_message` del objeto de red viene hardcodeado en
 * espanol dentro de `APIClient`, asi que mostrarlo tal cual le escribe en espanol a un usuario en
 * ingles. Quien enrute un `NETWORK_ERROR` a un cartel tiene que resolver el texto por i18n.
 *
 * NO sirve para decidir si algo salio bien: para eso esta `isOk`. Un caller que pregunte
 * `!isNetworkError(r)` deja pasar todos los errores tipados del backend.
 */
export function isNetworkError(response) {
    return !!response && response.error_code === 'NETWORK_ERROR';
}
